import axios from "axios";
import apiURI from "./Api";

export default class BankAccountService {
  _authHeader() {
    return {
      Authorization: "Bearer " + localStorage.getItem("__extraconomy_token"),
    };
  }

  async list() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/bankaccount/list`,
      headers: this._authHeader(),
    });
    return response.data;
  }

  async create(payload) {
    const body =
      payload.type === "PAYPAL"
        ? { type: payload.type, paypalEmail: payload.paypalEmail }
        : {
            type: payload.type,
            accountOwner: payload.accountOwner,
            bankname: payload.bankname,
            iban: payload.iban,
          };
    const response = await axios({
      method: "post",
      url: `${apiURI}/bankaccount/create`,
      data: body,
      headers: this._authHeader(),
    });
    return response.data;
  }

  async update(payload) {
    const body =
      payload.type === "PAYPAL"
        ? { id: payload.id, type: payload.type, paypalEmail: payload.paypalEmail }
        : {
            id: payload.id,
            type: payload.type,
            accountOwner: payload.accountOwner,
            bankname: payload.bankname,
            iban: payload.iban,
          };
    const response = await axios({
      method: "post",
      url: `${apiURI}/bankaccount/update`,
      data: body,
      headers: this._authHeader(),
    });
    return response.data;
  }

  async delete(payload) {
    const body = {
      id: payload.id,
      type: payload.type,
      accountOwner: payload.accountOwner ?? "",
      bankname: payload.bankname ?? "",
      iban: payload.iban ?? "",
      paypalEmail: payload.paypalEmail ?? "",
      defaultAccount: payload.defaultAccount ?? payload.isDefault ?? false,
    };
    const response = await axios({
      method: "post",
      url: `${apiURI}/bankaccount/delete`,
      data: body,
      headers: this._authHeader(),
    });
    return response.data;
  }

  async setAsDefault(id) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/bankaccount/setasdefault/${id}`,
      headers: this._authHeader(),
    });
    return response.data;
  }
}
